import { Box } from "@mui/material";
import DataGridCustom from "components/DataGridCustom";
import DataGridCustomToolbar from "components/DataGridCustomToolbar";
import React from "react";
import { useGetAllUsersQuery } from "state/api";
import UpdateUser from "./updateUser";
import DeleteUser from "./deleteUser";

const UserTable = () => {
  const { data, isLoading } = useGetAllUsersQuery(); // Fetching data from the API
  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
    },
    {
      field: "role",
      headerName: "Role",
      flex: 1,
    },
    {
      field: "reportTo",
      headerName: "Reports To",
      flex: 1,
      renderCell: (params) => {
        return (
          <div>{data?.result?.find(d => d._id === params.row.reportTo)?.name}</div>
        )
      }
    },

    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "contact",
      headerName: "Contact",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => {
        return (
          // display in flex update and delete button
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            className="gap-2"
          >
            <UpdateUser data={params.row} />
            <DeleteUser data={params.row} />
          </Box>
        );
      },
    },
  ];

  return (
    <Box mt="40px" width="100%" height="75vh">
      <DataGridCustom
        loading={isLoading || !data}
        getRowId={(row) => row._id}
        rows={(data && data.result) || []}
        columns={
          // align header to center
          columns.map((column) => ({
            ...column,
            headerAlign: "center",
            align: "center",
          }))
        }
        disableSelectionOnClick
        rowCount={(data && data.total) || 0}
        rowsPerPageOptions={[10, 20, 50]}
        components={{ Toolbar: DataGridCustomToolbar }}
        autoHeight
        sx={{
          width: "100%",
        }}
      />
    </Box>
  );
};

export default UserTable;
